<div class="main-content">
  <div class="contactus-main">
    <h1>Contact Us</h1>
    <div class="container">
      <div class="information">
        <div class="row align-items-center">
          <div class="col-12 col-md-4">
            <h2>Support information</h2>

          </div>
          <div class="col-12 col-md-4">
            <div class="information-main">
              <img loading="lazy" src="{{environment?.blobUrl}}/assets/images/contact-us/location.svg" alt="Location | Luminous">
              <h4>Registered Office</h4>
              <h5>Luminous Power Technologies Pvt. Ltd.</h5>
              <p>C-56, Mayapuri Industrial Area Phase-2 Mayapuri, New Delhi - 110064</p>
              <a href="" class="arrow">View on Map</a>
            </div>
          </div>
          <div class="col-12 col-md-4">
            <div class="information-main">
              <img loading="lazy" src="{{environment?.blobUrl}}/assets/images/contact-us/location.svg" alt="Location | Luminous">
              <h4>Corporate Office</h4>
              <h5>Luminous Power Technologies Pvt. Ltd.</h5>
              <p>Plot No. 150, Sector 44
                Gurgaon, Haryana - 122003.</p>
              <a href="" class="arrow">View on Map</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <app-help-support></app-help-support>
  </div>
</div>
